<script>
/**
 * "Opgaver" -> tasks
 */
import VProjectActionTaskForm from "@/components/Forms/VProjectActionTaskForm.vue";

import ProjectActionService from "@/services/ProjectActionService";
import Messages from "@/mixins/Messages";
import { EventBus } from "@/libraries/EventBus";
import { mapGetters } from "vuex";
import ProjectActionCategoryService from "@/services/ProjectActionCategoryService";
import VInlineEdit from "./VInlineEdit.vue";
// How many results per page
const PAGINATE_FETCH = "9999";

export default {
    props: {
        projectId: {},
        projectMomId: {},
        search: {},
        displayClosedActions: {
            type: Boolean,
            default: true,
            required: false
        },
        isPm: {
            type: Boolean,
            default: false
        }
    },
    components: { VProjectActionTaskForm, VInlineEdit },
    mixins: [Messages],
    data() {
        return {
            selectedFilter: "active",
            loading: true,
            items: [],
            meta: {},
            showModal: false,
            context: {},
            initStatus: {},
            open: true,
            suSaving: false,
            suError: "",
            showIDCol: true
        };
    },
    computed: {
        ...mapGetters("auth", ["getMyId"])
    },
    watch: {
        search: function(n) {
            this.fetchData();
        }
    },
    async created() {
        EventBus.$on("project-actions-reload-task", this.fetchData);
        EventBus.$on("project-actions-jump-task", this.jump);
        this.apiPaginator.sort = "due_date";
        this.apiPaginator.direction = "asc";
        this.apiPaginator.limit = PAGINATE_FETCH;
        await this.fetchData();
        this.loading = false;
    },
    beforeDestroy() {
        EventBus.$off("project-actions-reload-task");
        EventBus.$off("project-actions-jump-task");
    },
    methods: {
        async executeJump(target_id) {
            const params = {
                id: target_id,
                limit: PAGINATE_FETCH,
                project_id: this.projectId,
                action_type: "1",
                paginate: "yes"
            };
            const { data } = await ProjectActionService.GET_findPage(params);

            EventBus.$emit("project-actions-jump-status", {
                target_id,
                action_category_id: data.data.action_category_id,
                page: data.data.page
            });
        },
        async jump({ target_id }) {
            try {
                const params = {
                    id: target_id,
                    limit: PAGINATE_FETCH,
                    project_id: this.projectId,
                    action_type: "2",
                    paginate: "yes"
                };
                const { data } = await ProjectActionService.GET_findPage(
                    params
                );
                await this.fetchData({
                    sort: "due_date",
                    direction: "desc",
                    limit: PAGINATE_FETCH,
                    page: data.data.page
                });

                this.$nextTick(() => {
                    const row = document.querySelector(
                        `tr[data-id="${target_id}"]`
                    );
                    if (row) {
                        row.scrollIntoView({
                            behavior: "smooth",
                            block: "center"
                        });
                        row.classList.add("highlight-flash");
                        setTimeout(
                            () => row.classList.remove("highlight-flash"),
                            5000
                        );
                    }
                });
                // if (data.data.found)
            } catch (e) {
                console.log("jump e", e);
            }
        },
        async filter(type) {
            this.selectedFilter = type;
            this.fetchData();
        },
        async fetchData(replaceParams = null) {
            try {
                let params = this.$buildParams();
                if (replaceParams !== null) {
                    params = replaceParams;
                }

                console.log(params);
                params["project_id"] = this.projectId;
                params["action_type"] = "2";
                params["paginate"] = "yes";
                if (this.projectMomId) {
                    params["project_mom_id"] = this.projectMomId;
                } else {
                    params["context"] = "datatab";
                }

                if (
                    this.selectedFilter === "active" &&
                    replaceParams === null
                ) {
                    params["status"] = "0";
                } else {
                    delete params["status"];
                }

                const { data } = await ProjectActionService.GET(params);
                this.items = data.data;
                this.meta = data.meta;
                this.initStatus = data.meta.status;
            } catch (e) {
                console.log("fd e", e);
            }
        },
        /**
         * Force fetching of everything
         */
        async loadAll() {
            this.apiPaginator.limit = 9999;
            this.fetchData();
        },
        async updateText(item, new_text) {
            try {
                this.suSaving = true;
                this.suError = "";
                const data = {
                    id: item.id,
                    notes: new_text
                };

                await ProjectActionService.PUT(data);
                await this.fetchData();
            } catch (e) {
                console.log("E updateText", e);
                this.suError = e.response.data.errors;
            }

            this.suSaving = false;
        },
        closeReload() {
            EventBus.$emit("project-actions-reload-status");
            this.showModal = false;
            this.fetchData();
        },
        edit(ctx) {
            this.context = ctx;
            this.showModal = true;
        },
        copyToProject(item) {
            this.$askDeleteQuestion(
                this.$t("project_actions.copy_task_to_project_confirm"),
                async () => {
                    try {
                        await ProjectActionService.POST_copyToProject(item.id);
                        this.$msgSuccess(
                            this.$t(
                                "project_actions.copy_task_to_project_success"
                            )
                        );
                    } catch (e) {
                        this.$handleExceptionError(e, "Copy");
                    }
                }
            );
        },
        changeActionStatus(item) {
            this.$askDeleteQuestion(
                item.status === 1
                    ? this.$t("project_actions.change_task_open")
                    : this.$t("project_actions.change_task_closed"),
                async () => {
                    await ProjectActionService.PUT({
                        id: item.id,
                        status: item.status === 1 ? 0 : 1
                    });
                    await this.fetchData();
                }
            );
        }
    }
};
</script>

<template>
    <div class="v-project-action-table">
        <div class="mx-4 mb-3 d-flex justify-content-end">
            <div>
                <base-button
                    size="sm"
                    :type="selectedFilter == 'active' ? 'primary' : 'secondary'"
                    @click="filter('active')"
                    >{{ $t("actions.filter_active") }}</base-button
                >

                <base-button
                    size="sm"
                    :type="selectedFilter == 'all' ? 'primary' : 'secondary'"
                    @click="filter('all')"
                    >{{ $t("actions.filter_all") }}</base-button
                >
                <span
                    @click="showIDCol = !showIDCol"
                    class="m-click text-primary ml-2 mr-2"
                    ><i
                        class="fas fa-fw"
                        :class="{
                            'fa-eye': showIDCol,
                            'fa-eye-slash': !showIDCol
                        }"
                    ></i>
                    ID</span
                >
            </div>
        </div>

        <v-loader :loading="loading" v-if="loading" />
        <div v-else-if="!items.length">
            <div class="mx-4 mt-3 mb-2 small text-warning text-bold">
                <i class="far fa-exclamation-triangle"></i>
                {{ $t("project_actions.no_tasks") }}
            </div>
            <base-button
                type="link"
                class="mx-3 mb-5"
                size="sm"
                @click="edit({ empty: true })"
                ><i class="far fa-plus"></i>
                {{ $t("project_actions.add_task") }}</base-button
            >
        </div>
        <template v-else-if="open">
            <v-table class="table table-mg table-sm ">
                <v-thead>
                    <v-tr>
                        <v-th v-show="showIDCol">
                            <v-sorter
                                :paginator="apiPaginator"
                                name="id"
                                @sort="$handleSorting($event)"
                                >{{ $t("project_actions.hdr_id") }}
                            </v-sorter>
                        </v-th>
                        <v-th v-if="false">
                            <v-sorter
                                :paginator="apiPaginator"
                                name="created"
                                @sort="$handleSorting($event)"
                                >{{ $t("project_actions.hdr_date") }}
                            </v-sorter>
                        </v-th>
                        <v-th>
                            <v-sorter
                                :paginator="apiPaginator"
                                name="notes"
                                @sort="$handleSorting($event)"
                                >{{ $t("project_actions.hdr_description") }}
                            </v-sorter>
                        </v-th>
                        <v-th>
                            <v-sorter
                                :paginator="apiPaginator"
                                name="user_id"
                                @sort="$handleSorting($event)"
                                >{{ $t("project_actions.hdr_owner") }}
                            </v-sorter>
                        </v-th>
                        <v-th>
                            <v-sorter
                                :paginator="apiPaginator"
                                name="due_date"
                                @sort="$handleSorting($event)"
                                >{{ $t("project_actions.hdr_due") }}
                            </v-sorter>
                        </v-th>
                        <v-th style="text-align: center;">
                            <v-sorter
                                :paginator="apiPaginator"
                                name="status"
                                @sort="$handleSorting($event)"
                                >{{ $t("project_actions.hdr_status") }}
                            </v-sorter>
                        </v-th>
                        <v-th></v-th>
                    </v-tr>
                </v-thead>

                <v-tbody>
                    <v-tr
                        v-for="item in items"
                        :key="item.id"
                        :id="'action-' + item.id"
                        :data-id="item.id"
                        v-if="
                            displayClosedActions ||
                                (!displayClosedActions && item.status !== 1)
                        "
                    >
                        <v-td class="hdr__id" v-show="showIDCol">
                            {{ item.serial_number }}
                        </v-td>
                        <v-td class="hdr__date" v-if="false">
                            {{ $d(new Date(item.created), "short") }}
                        </v-td>
                        <v-td class="hdr__description preserve-newlines">
                            <div class="d-flex">
                                <v-inline-edit
                                    :text="item.notes"
                                    @save="updateText(item, $event)"
                                    :saving="suSaving"
                                    :error="suError"
                                />
                                <div
                                    v-if="'linked_action' in item"
                                    style="flex-grow: 1; text-align: right"
                                    class="m-click"
                                    @click="executeJump(item.linked_action_id)"
                                >
                                    <i class="far fa-link fa-fw fa-lg"></i>
                                </div>
                            </div>
                        </v-td>
                        <v-td class="hdr__user">
                            {{ item.user.name }}
                        </v-td>
                        <v-td class="hdr__date">
                            <template v-if="item.due_date">
                                {{ $d(new Date(item.due_date), "short") }}
                            </template>
                            <template v-else>---</template>
                        </v-td>
                        <v-td style="text-align: center;" class="hdr__status">
                            <template v-if="item.action_type == 2">
                                <i
                                    @click="changeActionStatus(item)"
                                    :class="{
                                        'status-closed': item.status === 1
                                    }"
                                    class="status-icon far fa-lg fa-check-circle"
                                ></i>
                            </template>
                            <template v-else>---</template>
                        </v-td>
                        <v-td class="hdr__action">
                            <i
                                v-if="projectMomId"
                                class="far fa-share fa-lg m-click text-primary mr-2"
                                @click="copyToProject(item)"
                            ></i>
                            <i
                                class="far fa-pencil fa-lg m-click"
                                @click="edit(item)"
                            ></i>
                        </v-td>
                    </v-tr>
                </v-tbody>
            </v-table>
            <div class="mt-1 mb-5">
                <base-button
                    type="link"
                    class="mx-3"
                    size="sm"
                    @click="edit({ empty: true })"
                    ><i class="far fa-plus"></i>
                    {{ $t("project_actions.add_task") }}</base-button
                >

                <base-button
                    v-if="meta.pagination.total_pages > 1"
                    type="link"
                    class="mx-3"
                    size="sm"
                    @click="loadAll"
                    ><i class="far fa-eye"></i>
                    {{ $t("project_actions.load_all") }}</base-button
                >

                <div class="paginator" v-if="meta.pagination.total_pages > 1">
                    <base-pagination
                        :page-count="meta.pagination.total_pages"
                        :per-page="meta.pagination.per_page"
                        :value="meta.pagination.current_page"
                        @input="$handlePagination($event)"
                    />
                </div>
            </div>
        </template>
        <template v-else-if="!open">
            <div class="mx-4 small text-muted mb-4">
                {{
                    $t("project_actions.closed_info_CLOSED_TOTAL", {
                        CLOSED: initStatus.closed,
                        TOTAL: initStatus.total
                    })
                }}
            </div>
        </template>
        <portal to="modals">
            <v-project-action-task-form
                v-if="showModal"
                :context="context"
                :project-id="projectId"
                :project-mom-id="projectMomId"
                @close-reload="closeReload"
                @close="showModal = false"
            />
        </portal>
        <hr class="mt-0 pt-0" />
    </div>
</template>

<style scoped>
.status-icon {
    color: #ddd;
}

.status-closed {
    color: rgb(120, 158, 107);
}

.preserve-newlines {
    white-space: pre-line;
}
</style>

<style lang="scss">
.v-project-action-table {
    .hdr__id {
        width: 140px;
    }

    .hdr__date {
        width: 110px;
    }

    .hdr__user {
        width: 200px;
    }

    .hdr__status {
        width: 100px;
    }

    .hdr__action {
        width: 100px;
    }
}
</style>
